import { FC } from 'react'
import { withSSRContext } from 'aws-amplify'

import { MAPS_LIMIT } from '~user-profile/constants'
import {
  GetUserByIdResults,
  getUserByIdQueryFn
} from '~user-profile/queries/useGetUserById'
import {
  SearchMapsResults,
  searchMapsQueryFn
} from '~user-profile/queries/useSearchMaps'
import { QueryProvider } from '~user-profile/providers/QueryProvider'
import { UserProfile } from './UserProfile'
import { mapsSortOptions } from 'ui-components'

type GetServerSidePropsProps = {
  searchMapsResults: SearchMapsResults
  getUserByIdResults: GetUserByIdResults
}

export type AppProps = GetServerSidePropsProps

export const App: FC<AppProps> = (props) => {
  return (
    <QueryProvider>
      <UserProfile {...props} />
    </QueryProvider>
  )
}

export const getServerSideProps = async (context /*{ params, query }*/) => {
  const { params, query, req } = context || {}
  const { userId } = params || {}

  if (!userId) {
    return {
      notFound: true
    }
  }

  const [field, order] = (query.sortBy || mapsSortOptions[1]!.value)
    .toString()
    .split('|')

  const [searchMapsResults, getUserByIdResults] = await Promise.all([
    searchMapsQueryFn(
      {
        creatorId: String(userId),
        limit: MAPS_LIMIT,
        sortBy: { field, order }
      },
      withSSRContext({ req })
    ),
    getUserByIdQueryFn({ id: String(userId) })
  ])

  return {
    props: {
      searchMapsResults,
      getUserByIdResults
    }
  }
}
